module.exports = __webpack_public_path__ + "static/media/CSL_Esports_Primary_Blue.a8b07ed7.png";